<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/web/wo/feeding/record/page" ref="yt" getKey="rows" :columns="columns"> </yi_curd_table>
  </div>
</template>

<script>
export default {
  name: 'web_material_management_mixture_feeding_list',
  props: {
    // 父组件传过来的参数
    mixtureOrderId: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      columns: [
        {
          label: 'touliaoshijian',
          prop: 'feedingTime',
          type: 'time'
        },
        {
          label: 'yuancailiaobiaoqiantiaomahao',
          prop: 'labelRawMaterials.barCode'
        },
        {
          label: 'yuancailiaobiaoqianshuliang',
          prop: 'labelRawMaterials.quantity'
        },
        {
          label: 'touliaowuliaobianma',
          prop: 'material.code'
        },
        {
          label: 'touliaowuliaomingcheng',
          prop: 'material.name'
        },
        {
          label: 'touliaoshuliang',
          prop: 'feedingWeight'
        },
        {
          label: 'touliaoren',
          prop: 'feedingUser.nickname'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.mixOrderId = this.mixtureOrderId;
      this.yt.conditions.orderBy = 'createTime desc';
      this.yt.get(1);
    }, 300);
  }
};
</script>

<style scoped lang="scss"></style>
